module.exports = __webpack_public_path__ + "img/classify_4.7671c3af.png";